<template>
<div class="chapter">
<div class="inner_page">
      ﻿



<title>The Billionaire's Bride of Innocence</title>
<link href="pdlmsr.css" rel="stylesheet" type="text/css"/>
<meta content="application/xhtml+xml; charset=utf-8" http-equiv="content-type"/>
<div class="titlePage" id="tp01"><a id="pageiv"><h2 class="titlePageAuthor"><span class="bold"><span><em class="italic"><span>Miranda Lee</span></em></span></span></h2><h2 class="titlePageTitle"><span class="bold"><span>THE BILLIONAIRE’S BRIDE OF INNOCENCE</span></span></h2><br/><br/><p class="centerImage1"><img alt="image" src="Images/02.jpg"/></p><p class="image"><span><img alt="image" src="Images/logo.jpg"/></span></p></a></div>
<a id="pageiv">
</a>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// billionairesbrideofinnocencethe_tp01.vue?6c1211fa